/**
 * Isometric grid constants, fixed by docs/00-vision.md §6.
 * Engine, art pipeline and (from M1) the server all import these; never
 * hard-code the numbers anywhere else.
 *
 * Projection (logical px at @1x, tx/ty are float tile coords, z is in
 * tile-height units where one storey = 3 units = 96 px):
 *   screenX = (tx - ty) * 32
 *   screenY = (tx + ty) * 16 - z * 32
 */
/** Tile footprint width in logical px (@1x). */
export const TILE_W = 64;
/** Tile footprint height in logical px (@1x). 2:1 dimetric. */
export const TILE_H = 32;
/** Half tile width: the x factor of the projection. */
export const TILE_HALF_W = TILE_W / 2; // 32
/** Half tile height: the y factor of the projection. */
export const TILE_HALF_H = TILE_H / 2; // 16
/** Logical px per z unit. */
export const Z_UNIT_PX = 32;
/** z units per storey. */
export const STOREY_Z = 3;
/** Wall height in logical px (= one storey). */
export const WALL_HEIGHT_PX = STOREY_Z * Z_UNIT_PX; // 96
/** Approximate standing character height in logical px. */
export const CHARACTER_HEIGHT_PX = 80;
/** Art is authored at @2x and downscaled for the low tier. */
export const ART_AUTHORED_SCALE = 2;
/** Maximum texture atlas edge in px (safe on mobile GPUs). */
export const ATLAS_MAX_PX = 2048;
/** Character frame canvas (logical px @1x). */
export const CHAR_FRAME_W = 64;
export const CHAR_FRAME_H = 128;
/** Feet anchor inside the character frame (logical px @1x). */
export const CHAR_FEET_X = 32;
export const CHAR_FEET_Y = 120;
/**
 * CLIENT fixed-step simulation rate (20 Hz = 50 ms). This is NOT the server
 * tick (`SERVER_TICK_HZ = 10` in protocol/limits): movement is replayed from
 * paths on a shared clock, so the two rates are independent (98 Q-01).
 */
export const CLIENT_SIM_HZ = 20;
export const CLIENT_SIM_MS = 1000 / CLIENT_SIM_HZ;
